// ═══════════════════════════════════════════════════════════════
// ClearView CRM CSV Parser — AFP Export Field Mapping
// Handles double-space in "Home  Zip/Postal Code", BOM markers,
// special characters, and quoted fields
// ═══════════════════════════════════════════════════════════════

export const CSV_FIELD_MAP = {
  "chapter": "chapter", "afp id": "afpId",
  "credentialed full name": "credentialedFullName",
  "first name": "firstName", "last name": "lastName",
  "personaccounttitle__c": "title", "cfre": "cfre",
  "designation": "designation", "member since": "memberSince",
  "start date": "startDate", "end date": "endDate",
  "member type": "memberType", "email": "email", "phone": "phone",
  "organization": "organization", "home street": "homeStreet",
  "home city": "homeCity", "home state/province": "homeState",
  "home  zip/postal code": "homeZip", "home zip/postal code": "homeZip",
  "home country": "homeCountry", "website": "website",
  "years of professional experience": "yearsExperience",
  "gender identity": "genderIdentity", "ethnicity": "ethnicity",
  "race/ethnicity": "raceEthnicity", "birthdate": "birthdate",
  "sexual orientation": "sexualOrientation",
  "does organization pays your annual dues?": "orgPaysDues",
  "does organization pays your annual dues": "orgPaysDues",
  "membership auto-renews": "autoRenews",
  "complimentary membership reason": "complimentaryReason",
  "membership journey": "membershipJourney"
};

/** Parse a single CSV line handling quoted fields and escaped quotes */
export const parseCsvLine = (line) => {
  const result = [];
  let current = "";
  let inQuotes = false;
  for (let i = 0; i < line.length; i++) {
    const char = line[i];
    if (char === '"') {
      if (inQuotes && line[i + 1] === '"') {
        current += '"';
        i++;
      } else {
        inQuotes = !inQuotes;
      }
    } else if (char === "," && !inQuotes) {
      result.push(current.trim());
      current = "";
    } else {
      current += char;
    }
  }
  result.push(current.trim());
  return result;
};

/**
 * Parse CSV text into an array of member objects
 * @param {string} csvText - Raw CSV file content
 * @returns {{ members: Array, mappedFieldCount: number }}
 */
export const parseCSVMembers = (csvText) => {
  const lines = csvText.split(/\r?\n/).filter(line => line.trim());
  if (lines.length < 2) throw new Error("No data rows found in CSV");

  const headers = parseCsvLine(lines[0]).map(header =>
    header.toLowerCase().replace(/^\uFEFF/, "").replace(/[^\w\s/:]/g, "").trim()
  );

  let mappedFieldCount = 0;
  headers.forEach(header => {
    if (CSV_FIELD_MAP[header]) mappedFieldCount++;
  });

  const members = [];
  for (let i = 1; i < lines.length; i++) {
    const values = parseCsvLine(lines[i]);
    if (values.length < 2) continue;

    const member = {};
    headers.forEach((header, index) => {
      const field = CSV_FIELD_MAP[header];
      if (field && values[index]) {
        member[field] = values[index].trim();
      }
    });

    // Map membership journey to pathway
    if (member.membershipJourney) {
      const journey = member.membershipJourney.toLowerCase();
      member.pathway = journey.includes("lead") ? "lead"
        : journey.includes("contribut") ? "contribute"
        : "unengaged";
    }

    if (member.firstName || member.lastName) {
      members.push(member);
    }
  }

  return { members, mappedFieldCount };
};
